import React from 'react'
import { Card, Button } from 'react-bootstrap'
import { Plus } from 'lucide-react'
import { NotificationCard } from '../styles'

// NotificationCard now imported from ../styles

interface NoModelsCardProps {
  title?: string
  description?: string
  onCreateModel: () => void
}

const NoModelsCard: React.FC<NoModelsCardProps> = ({
  title = 'No Models Available',
  description = 'Get started by creating your first model. You can train it on your dataset and deploy it for inference.',
  onCreateModel,
}) => {
  return (
    <NotificationCard>
      <div className="icon-wrapper">
        <Plus color="white" size={24} />
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
      <Button onClick={onCreateModel}>
        <Plus size={18} />
        Create New Model
      </Button>
    </NotificationCard>
  )
}

export default NoModelsCard
